// src/App.js

import React from 'react';
import './App.css';
import ConferenceTemplate from './components/ConferenceTemplate';

function App() {
  return (
    <div className="App">
      <ConferenceTemplate />
    </div>
  );
}

export default App;